<script setup lang="ts">
interface Props {
  count?: number
}

const props = withDefaults(defineProps<Props>(), {
  count: 5
})
</script>

<template>
  <div class="space-y-4">
    <article
      v-for="n in props.count"
      :key="n"
      class="Card animate-pulse rounded-md border p-4 shadow-sm"
    >
      <div class="flex flex-col space-y-4">
        <div class="flex items-start justify-between">
          <div class="flex flex-1 items-start gap-4">
            <div class="flex-shrink-0">
              <div class="overflow-hidden rounded-md border p-1.5">
                <div class="h-12 w-12 rounded bg-gray-300" />
              </div>
            </div>
            <div class="flex-1 space-y-1">
              <div class="h-5 w-40 rounded bg-gray-300" />
              <div class="h-4 w-32 rounded bg-gray-300" />
            </div>
          </div>
          <div class="flex flex-wrap gap-1">
            <div class="h-6 w-16 rounded-full bg-gray-300" />
            <div class="h-6 w-16 rounded-full bg-gray-300" />
          </div>
        </div>

        <hr class="w-full border-t border-gray-200" />

        <div class="space-y-3">
          <div class="flex items-center gap-2">
            <div class="h-5 w-5 flex-shrink-0 rounded bg-gray-300" />
            <div class="h-4 w-48 rounded bg-gray-300" />
          </div>
          <div class="flex items-center gap-2">
            <div class="h-5 w-5 flex-shrink-0 rounded bg-gray-300" />
            <div class="h-4 w-40 rounded bg-gray-300" />
          </div>
          <div class="flex items-center gap-2">
            <div class="h-5 w-5 flex-shrink-0 rounded bg-gray-300" />
            <div class="h-4 w-32 rounded bg-gray-300" />
          </div>
        </div>

        <hr class="w-full border-t border-gray-200" />

        <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div class="flex flex-wrap items-center gap-2">
            <div class="h-4 w-16 rounded bg-gray-300" />
            <div class="flex flex-wrap gap-2">
              <div class="h-6 w-16 rounded-full bg-gray-300" />
              <div class="h-6 w-16 rounded-full bg-gray-300" />
              <div class="h-6 w-16 rounded-full bg-gray-300" />
            </div>
          </div>
          <div class="md:ml-auto">
            <div class="h-4 w-28 rounded bg-gray-300" />
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
